import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "select-invoice-template" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "container mx-auto flex px-5 pt-24 items-center justify-center flex-col" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "hero-title" }, "Select Invoice Template")
  ])
], -1)
const _hoisted_3 = { class: "inv-preview-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_invoice_template_preview = _resolveComponent("invoice-template-preview")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_invoice_template_preview)
    ])
  ]))
}